import { gql } from '@apollo/client';

export const UPDATE_APPLICATION = gql`
  mutation updateApplication($data: AppUpdateInput!) {
    updateApplication(data: $data) {
      data {
        id
        appName
        appLogo
        createdAt
      }
      message
    }
  }
`;

export const REMOVE_APP_MEMBER = gql`
  mutation removeAppMember($referenceId: ID!, $appId: ID!) {
    removeAppMember(referenceId: $referenceId, appId: $appId) {
      message
    }
  }
`;

export const DELETE_RELEASE = gql`
  mutation deleteRelease($uniqueId: String!) {
    deleteRelease(uniqueId: $uniqueId) {
      message
    }
  }
`;

export const UPDATE_RELEASE_NOTE = gql`
  mutation updateReleaseNote($data: ReleaseUpdateInput!) {
    updateReleaseNote(data: $data) {
      message
    }
  }
`;

export const DELETE_APPLICATION = gql`
  mutation deleteApp($appId: ID!) {
    deleteApplication(appId: $appId) {
      message
    }
  }
`;

export const UPDATE_DOWNLOAD_COUNT = gql`
  mutation updateDownload($subLinkId: String, $applicationDetailId: ID) {
    updateDownloadCount(
      subLinkId: $subLinkId
      applicationDetailId: $applicationDetailId
    ) {
      message
    }
  }
`;

export const UPDATE_SHAREABLE_LINK = gql`
  mutation updateShareableLink($data: UpdateShareableLinkInput!) {
    updateShareableLink(data: $data) {
      message
    }
  }
`;

export const DELETE_SHARABLE_LINK = gql`
  mutation deleteSharableLink($uniqueId: String!, $subLinkId: ID!) {
    deleteShareableLink(uniqueId: $uniqueId, subLinkId: $subLinkId) {
      message
    }
  }
`;

export const INVITE_MEMBER_IN_APPLICATION = gql`
  mutation inviteMemberInApplication(
    $appId: ID!
    $data: [InviteMemberGroupInAppInput]!
  ) {
    inviteMemberInApplication(appId: $appId, data: $data) {
      message
    }
  }
`;

export const UPGRADE_APPLICATION = gql`
  mutation upgradeApplication($data: AppUpgradeApplication!) {
    upgradeApplication(data: $data) {
      message
    }
  }
`;

export const MAINTENANCE_APPLICATION = gql`
  mutation maintenanceApplication($data: AppMaintenanceInput!) {
    appMaintenance(data: $data) {
      message
    }
  }
`;

export const CREATE_SHAREABLE_LINK = gql`
  mutation createShareableLink($data: ShareableLinkInput!) {
    createShareableLink(data: $data) {
      message
      link
    }
  }
`;

export const RESOLVE_RELEASE_FEEDBACK = gql`
  mutation resolveReleaseFeedback($data: ResolveReleaseFeedbackInput!) {
    resolveReleaseFeedback(data: $data) {
      message
    }
  }
`;
